import React from 'react';
import {ErrorBoundaryFallbackUI} from '@stripe-internal/connect-embedded-lib';
import {useIntl} from '@sail/intl';
import type {ConnectElementMessages} from './ConnectJSInterface/ConnectElementList';
import {defaultErrorMessages} from './ConnectElementErrorBoundary';

export const ConnectElementErrorBoundaryUi: React.FC<{
  messages?: ConnectElementMessages;
}> = ({messages}) => {
  const intl = useIntl();

  return (
    <ErrorBoundaryFallbackUI
      header={intl.formatMessage(
        messages?.errorHeader ?? defaultErrorMessages.defaultErrorMessageHeader,
      )}
      text={intl.formatMessage(
        messages?.errorText ?? defaultErrorMessages.defaultAuthErrorMessageText,
      )}
    />
  );
};
